require('./js/app')
require('./js/scac-front.js')
require('./sass/app.scss')
